import { LoadingScreen } from "@/components/LoadingScreen";
import { useAuth } from "@/hooks/useAuth";
import { useEffect, type ReactNode } from "react";

export function AuthGuard({ children }: { readonly children: ReactNode }) {
  const { isAuthenticated, error, user, login } = useAuth();

  useEffect(() => {
    if (!isAuthenticated && !error) {
      login(location.pathname);
    }
  }, [isAuthenticated, error]);

  if (!isAuthenticated || error) {
    return null;
  }

  if (!user) {
    return <LoadingScreen />;
  }

  return children;
}
